module.exports = __webpack_public_path__ + "img/Wekiwi_120X35.26abcef1.png";